import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type PrecificacaoCompatibilidadeResponse = {
  compatibilidadeId: number;
  possuiValorDisponivel: boolean;
  valorDisponivel?: number | string;
  dataCalculo?: string;
  dataCheckin?: string;
  dataCheckout?: string;
  pagamento?: {
    pix?: {
      valor?: number | string;
    };
    cartao?: {
      quantidadeParcelas?: number;
      valorParcela?: number | string;
      valorTotal?: number | string;
    };
  };
  precificacao?: any;
  mensagem?: string;
};

export const buscarPrecificacaoCompatibilidadeService = async (
  compatibilidadeId: number
): Promise<PrecificacaoCompatibilidadeResponse | false> => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/compatibilidades/${compatibilidadeId}/precificacao`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return false;
};
